import React from 'react'
import { Box, Button, Text } from 'grommet'
import { I18n } from 'galarm-config'
import GalarmWebHeader from './GalarmWebHeader'

const PremiumCancelScreen = () => (
  <Box fill background="#f9f9fb">
    <GalarmWebHeader />
    <Box flex overflow="auto" align="center" justify="start" pad="large">
      <Box
        background="white"
        round="small"
        pad="xlarge"
        align="center"
        gap="medium"
        flex={{ shrink: 0 }}
        width={{ max: '440px' }}
        style={{ boxShadow: '0 2px 16px rgba(0,0,0,0.08)', width: '100%' }}>
        <Box
          width="72px"
          height="72px"
          round="full"
          background="light-3"
          align="center"
          justify="center"
          style={{ fontSize: '2rem' }}>
          <Text style={{ fontSize: '2rem', lineHeight: 1 }}>✕</Text>
        </Box>

        <Box align="center" gap="xsmall">
          <Text
            size="xlarge"
            weight="bold"
            color="dark-1"
            textAlign="center"
            style={{ letterSpacing: '-0.3px' }}>
            {I18n.t('premiumPurchaseCancelledTitle')}
          </Text>
          <Text textAlign="center" color="dark-4" size="small">
            {I18n.t('premiumPurchaseCancelled')}
          </Text>
        </Box>

        <Box gap="small" style={{ marginTop: '8px' }} width="100%">
          <Button
            primary
            label={<Text color="white">{I18n.t('tryAgain')}</Text>}
            onClick={() => (window.location.href = '/premium')}
            style={{
              borderRadius: '8px',
              fontWeight: 600,
              padding: '12px 32px'
            }}
          />
          <Button
            label={I18n.t('close')}
            onClick={() => window.open('https://www.galarmapp.com', '_self')}
            style={{
              borderRadius: '8px',
              padding: '12px 32px',
              border: '1px solid #d0d0d8'
            }}
          />
        </Box>
      </Box>
    </Box>
  </Box>
)

export default PremiumCancelScreen
